// extracted by mini-css-extract-plugin
export default {"values":"Values_values__FzkyD","values-container":"Values_values-container__Lk2gs"};